import { createRouter, createWebHistory } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';
import { createRouterGuard } from "./guard";
import { routes as customRoutes } from "./routes/index";
import type { App } from "vue";
import {
  type RouterHistory,
  createMemoryHistory,
  createWebHashHistory,
} from "vue-router";
import "nprogress/nprogress.css";
// 自定义路由
const baseRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'root',
    redirect: '/home'
  },
];

// 创建路由实例
export const router = createRouter({
  history: createWebHistory(),
  routes: [...baseRoutes, ...customRoutes]
});

const historyCreatorMap: Record<
  string,
  (base?: string) => RouterHistory
> = {
  hash: createWebHashHistory,
  history: createWebHistory,
  memory: createMemoryHistory,
};

// 导出路由安装函数
export async function setupRouter(app: App) {
  // 先安装路由插件
  app.use(router);
  createRouterGuard(router);
  await router.isReady();
}

export default router;
